const { languages, defaultLanguage } = require('../../locales');

const disabledPagesForIntl = [
  '/where-to-buy/',
  '/about-us/donation-requests/',
  '/about-us/donation-requests/fail/',
  '/about-us/donation-requests/success/',
  '/support/register/',
  '/support/register/fail/',
  '/support/register/success/',
];

function getAllowedLanguages() {
  return languages;
}

function getAllowedLanguagesForPage(page) {
  if (disabledPagesForIntl.includes(page.path)) return [defaultLanguage];

  return getAllowedLanguages();
}

module.exports = {
  getAllowedLanguages,
  getAllowedLanguagesForPage,
};
